


































import Vue from "vue";
import configProvider from "@/services/configProvider";

// OAuth2 loopback callback view, routed at /user/oauth2/callback (the public
// callback URL the edge routes to this container). It forwards the OAuth params
// (code, state) to wherever the flow was initiated. Both targets are resolved
// from configProvider so they can be overridden per deployment; the defaults
// below preserve the previous hardcoded behavior.
const DEFAULT_MOBILE_SCHEME = "msuite://oauth2";
const DEFAULT_DESKTOP_CALLBACK_URL = "https://localhost:40001/ui/oauth2-callback";

export default Vue.extend({
  data() {
    return {
      isMobile: false,
      // Custom-scheme deep link (with OAuth params) backing the manual fallback link.
      deepLink: "",
    };
  },
  mounted() {
    // Forward the OAuth params verbatim, including any hash fragment.
    const params = window.location.search + window.location.hash;
    const ua = navigator.userAgent;
    const isIOS = /iPhone|iPad|iPod/i.test(ua);
    const isAndroid = /Android/i.test(ua);
    this.isMobile = isIOS || isAndroid || /webOS|BlackBerry|IEMobile|Opera Mini/i.test(ua);

    if (!this.isMobile) {
      // Desktop: forward straight to the agent's loopback HTTP server.
      const target = configProvider.get("OAUTH2_DESKTOP_CALLBACK_URL", DEFAULT_DESKTOP_CALLBACK_URL) + params;
      window.location.replace(target);
      return;
    }

    // Custom-scheme deep link (with OAuth params); backs the manual button and,
    this.deepLink = configProvider.get("OAUTH2_MOBILE_SCHEME", DEFAULT_MOBILE_SCHEME) + params;
    if (this.deepLink !== "") {
      window.location.href = this.deepLink;
    }
  },
});
